import { handlePost } from "./axios";


export const postMessageTalkJs =async (requestParam: any) => {
  const response = await handlePost('/talk-js/message', null, requestParam)
  return response;
}